import React from 'react';
import { JEELogo, NEETLogo, BITSATLogo, NDALogo, VITEEELogo } from './icons/ExamLogos';
import { HomeIcon } from './icons/InterfaceIcons';

const exams = [
  { id: 'jee-main', name: 'JEE Main & Advanced', icon: <JEELogo className="h-5 w-5 object-contain" /> },
  { id: 'neet', name: 'NEET', icon: <NEETLogo className="h-5 w-5 object-contain" /> },
  { id: 'bitsat', name: 'BITSAT', icon: <BITSATLogo className="h-5 w-5 object-contain" /> },
  { id: 'nda', name: 'NDA', icon: <NDALogo className="h-5 w-5 object-contain" /> },
  { id: 'viteee', name: 'VITEEE', icon: <VITEEELogo className="h-5 w-5 object-contain" /> },
];

// FIX: Add explicit types for props to allow 'key' prop in map.
const FilterItem: React.FC<{ icon: React.ReactNode; label: string; active: boolean; onClick: () => void; }> = ({ icon, label, active, onClick }) => (
  <button
    onClick={onClick}
    className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all text-sm w-full text-left cursor-pointer ${
      active
        ? 'bg-brand-primary/10 text-brand-primary font-semibold'
        : 'text-brand-text-secondary hover:bg-brand-surface/50 hover:text-brand-text-primary dark:hover:bg-zinc-700'
    }`}
  >
    {icon}
    <span>{label}</span>
  </button>
);

export const LeftRail = ({ isOpen, activeExamId, onSelectExam, onNavigateToHome }) => {
  return (
    <aside
      id="left-rail"
      className={`
        flex-shrink-0 bg-brand-surface border-r border-brand-border
        transition-all duration-300 ease-in-out
        fixed lg:relative inset-y-0 left-0 z-30
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0 ${isOpen ? 'w-64' : 'lg:w-20'}
      `}
    >
      <div className={`p-4 h-full flex flex-col transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'pointer-events-none lg:opacity-0'}`}>
         {/* This div is for content that hides when collapsed */}
        <nav className="flex-1 space-y-4 pt-16 lg:pt-0">
           <div>
            <h3 className="px-3 text-xs font-semibold text-brand-text-secondary uppercase tracking-wider mb-2">Navigation</h3>
            <div className="space-y-1">
              <FilterItem
                icon={<HomeIcon className="h-5 w-5" />}
                label="Home"
onClick={onNavigateToHome}
              />
            </div>
          </div>
          <div className="border-t border-brand-border pt-4">
            <h3 className="px-3 text-xs font-semibold text-brand-text-secondary uppercase tracking-wider mb-2">Practice Questions</h3>
            <div className="space-y-1">
              {exams.map(exam => (
                <FilterItem
                  key={exam.id}
                  icon={exam.icon}
                  label={exam.name}
                  active={activeExamId === exam.id}
                  onClick={() => onSelectExam(exam.id)}
                />
              ))}
            </div>
          </div>
        </nav>
      </div>

       {/* This div is for icons that show when collapsed on desktop */}
      <div className={`absolute top-0 left-0 w-full p-4 h-full flex-col items-center transition-opacity duration-300 ${!isOpen ? 'lg:opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <nav className="flex-1 space-y-4 pt-4 flex flex-col items-center">
             <button
                onClick={onNavigateToHome}
                className={`p-3 rounded-lg hover:bg-brand-surface/50 dark:hover:bg-zinc-700 cursor-pointer`}
                title="Home"
            >
                <HomeIcon className="h-6 w-6 text-brand-text-secondary" />
             </button>
            {exams.map(exam => (
                 <button
                    key={exam.id}
                    onClick={() => onSelectExam(exam.id)}
                    className={`p-3 rounded-lg cursor-pointer ${activeExamId === exam.id ? 'bg-brand-primary/10' : 'hover:bg-brand-surface/50 dark:hover:bg-zinc-700'}`}
                    title={exam.name}
                >
                    {React.cloneElement(exam.icon, { className: 'h-6 w-6 object-contain' })}
                 </button>
            ))}
        </nav>
      </div>
    </aside>
  );
};